import React from "react";
import { Carousel } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";

import { homeCarouselData } from "../data/homeCarouselData";
import HomeCarouselCard from "./HomeCarouselCard";

const HomeCarousel = () => {
  const { i18n } = useTranslation();
  const isTelugu = i18n.resolvedLanguage === "te";
  return (
    <Carousel className="rounded-xl">
      {homeCarouselData.map((section) => {
        const { id, title, titleTe, desc, descTe, image, imageDesc, path } = section;
        return (
          <HomeCarouselCard
            title={isTelugu ? titleTe : title}
            desc={isTelugu ? descTe : desc}
            image={image}
            imageDesc={imageDesc}
            path={path}
            key={id}
          />
        );
      })}
    </Carousel>
  );
};

export default HomeCarousel;
